import { createSlice } from '@reduxjs/toolkit'

export const webviewSlice = createSlice({
  name: 'webview',
  initialState: {
    initialized: false,
    authFinished: false,
    priorityVenderIds: [],
  },
  reducers: {
    setWebviewName: (state, action) => {
      state.name = action.payload
    },
    setWebviewDevice: (state, action) => {
      state.device = action.payload
    },
    setWebviewAppVersion: (state, action) => {
      state.appVersion = action.payload
    },
    setWebviewOsVersion: (state, action) => {
      state.osVersion = action.payload
    },
    webviewInitialized: (state, action) => {
      state.initialized = true
    },
    setWebviewAuthFinished: (state, action) => {
      state.authFinished = action.payload
    },
    setSyStaffCode: (state, action) => {
      state.syStaffCode = action.payload
    },
    setAdditionalNote: (state, action) => {
      state.additionalNote = action.payload
    },
    setServiceAdminNote: (state, action) => {
      state.serviceAdminNote = action.payload
    },
    clearNotes: (state, action) => {
      const result = { ...state }
      delete result.additionalNote
      delete result.serviceAdminNote
      return result
    },
    setPriorityVenderIds: (state, action) => {
      state.priorityVenderIds = action.payload
    },
  },
})

export const selectWebview = (state) => state.webview
export const selectWebviewName = (state) => state.webview?.name

export const {
  setWebviewName,
  setWebviewDevice,
  setWebviewAppVersion,
  setWebviewOsVersion,
  webviewInitialized,
  setWebviewAuthFinished,
  setSyStaffCode,
  setAdditionalNote,
  setServiceAdminNote,
  clearNotes,
  setPriorityVenderIds,
} = webviewSlice.actions

export default webviewSlice.reducer
